// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Added Comment Lines
// MODIFIED DATE: 07-12-2025
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	getDailyCollectionReportDetailsFailure,
	getDailyCollectionReportDetailsResponseChanged,
	getDailyCollectionReportDetailsSuccess,
} from './daily-collection-report.action';
import DailyCollectionReportActionTypes from './daily-collection-report.type';
import { dailyCollectionReportListGet } from './daily-collection-report.service';

/** ***************** GET DAILY COLLECTION REPORT START *********************** */
export function* getDailyCollectionReportList({ payload }: any) {
	try {
		const key = 'DailyCollectionReportKey';
		const { companyID, branchID, databaseName, fromDate, toDate, userID, userLevel, loanType } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			UserID: userID,
			Userlevel: userLevel,
			LoanType: loanType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dailyCollectionReportListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDailyCollectionReportDetailsFailure(responseData.data));
		} else {
			yield put(getDailyCollectionReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDailyCollectionReportDetailsFailure(error));
	}
}

export function* resetgetDailyCollectionReportListResponse() {
	yield put(getDailyCollectionReportDetailsResponseChanged());
}

export function* onGetDailyCollectionReportListDetails() {
	yield takeLatest(
		DailyCollectionReportActionTypes.GET_DAILY_COLLECTION_REPORT_LIST_START,
		getDailyCollectionReportList,
	);
}

export function* onGetDailyCollectionReportListResponseReset() {
	yield takeLatest(
		DailyCollectionReportActionTypes.GET_DAILY_COLLECTION_REPORT_LIST_RESPONSE_RESET,
		resetgetDailyCollectionReportListResponse,
	);
}
/** ***************** GET DAILY COLLECTION REPORT END *********************** */

export function* dailyCollectionReportSaga() {
	yield all([
		call(onGetDailyCollectionReportListDetails),
		call(onGetDailyCollectionReportListResponseReset),
	]);
}
